<template>
    <ElDialog
        class="modal" 
        :visible.sync="showModal" 
        :width="modalWidth">
        <h2 class="modal__title">
            Успешная оплата!
        </h2>
        <div class="modal__body">
            <p class="modal__text">
                <span v-if="tariffName?.length">
                    Вы оплатили тариф "{{ tariffName }}"
                </span>
                <br>
              Ваш полис ипотечного страхования успешно оформлен и отправлен на указанную электронную почту.
            </p>
        </div>
        <div class="modal__submit-buttons">
            <BaseButton text="Закрыть окно" 
                size="large" 
                @click.native="closeModal" />
        </div>
    </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';
import { TARIFFS_TRANSLATIONS_MAP } from "@/consts";

export default {
    name: 'ModalPolicyIssuanceSuccess',
    components: {
        BaseButton
    },
    props: {
        variant: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            tariffName: '',
        }
    },
    mixins: [modal],
    mounted() {
        const { tariff } = this.$route.query;
        this.tariffName = TARIFFS_TRANSLATIONS_MAP[tariff] || ''

        const url = new URL(window.location.href);
        const sku = url.searchParams.get("orderId");
        const paymentType = url.searchParams.get("paymentType");

        let price = 0;

        if (paymentType == 'PAYMENT_SERVICE') {
          price = parseFloat(url.searchParams.get("paymentAmount"));
        } else {
          price = parseFloat(url.searchParams.get("paymentAmount") / 100);
        }

        const quantity = '1';
        const name = 'Страховой полис';

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({
          'ecommerce': {
            'purchase': {
              'actionField':
                {
                  'id': sku,
                }
              ,
              'products': [
                {
                  'id': sku,
                  'name':name,
                  'price': price.toString(),
                  'quantity':quantity,
                }
              ]
            }
          }
        });

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: sku,
            affiliation: "Cart",
            value: price.toString(),
            tax: 0,
            shipping: 0,
            currency: "RUB",
            items: [{
              item_name: name,
              item_id: sku,
              price: price.toString(),
              quantity: quantity,
              item_category: 'еИпотека'
            }]
          }
        });
    }
}
</script>